class AgeValidation extends HTMLElement {

  constructor(){
    super();
    this.closer = this.querySelector('.age-validation__close');
    this.listeners();
  }

  listeners(){
    let ageValidationForm = document.querySelector('#age-validation-form');
    this.closer.addEventListener('click', this.close.bind(this));
    const _this = this;
    ageValidationForm.addEventListener('submit', function(e){
      _this.formSubmit(e);
    });

    document.addEventListener('age-validation:show', (e) => {
      this.showPopup();
    });
    this.inputFlow();
  }

  close() {
    this.classList.remove("is-active");
    document.body.classList.remove('overflow-hidden', 'age-validation-active');
  }
  
  showPopup(){
    const body = document.querySelector('body'),
          popup = document.querySelector('.age-validation');

    if(body.classList.contains("age-validation-active")){
      body.classList.remove("age-validation-active");
      popup.classList.remove("is-active");
    } else {
      body.classList.add("age-validation-active");
      popup.classList.add("is-active");
    }

  }

  inputFlow(){
    let ageValidationForm = document.querySelector('#age-validation-form');
    if (ageValidationForm) {
      let day = ageValidationForm.querySelector('#AgeValidation-Day')
      let month = ageValidationForm.querySelector('#AgeValidation-Month')
      let year = ageValidationForm.querySelector('#AgeValidation-Year')
      let submit = ageValidationForm.querySelector('button[type="submit"]')

      day.addEventListener('keyup', function(e){
        if (day.value.length >= 2) {
          e.preventDefault()
          month.focus()
        }
      })

      month.addEventListener('keyup', function(e){
        if (month.value.length >= 2) {
          e.preventDefault()
          year.focus()
        }
      })

      year.addEventListener('keyup', function(e){
        if (year.value.length >= 4) {
          e.preventDefault()
          submit.focus()
        }
      })
    }
  }

  formSubmit(event){
    event.preventDefault()
    let popup = document.querySelector('.age-validation'),
        ageValidationForm = document.querySelector('#age-validation-form'),
        dayValue = ageValidationForm.querySelector('#AgeValidation-Day').value,
        monthValue = parseInt(ageValidationForm.querySelector('#AgeValidation-Month').value - 1),
        yearValue = ageValidationForm.querySelector('#AgeValidation-Year').value,
        ageInput = new Date(yearValue, monthValue, dayValue).toDateString(),
        ageCalc = this.getAge(ageInput),
        errorMessage = ageValidationForm.querySelector('#error-message');
    
    // Under age
    if (ageCalc < 16) {
      if (errorMessage) {
        errorMessage.classList.remove('hidden')
      }
    } else {
    // Legal age
      if (errorMessage) {
        errorMessage.classList.add('hidden')
      }

      document.body.classList.remove('overflow-hidden');
      popup.classList.remove("is-active");

      var date = new Date();
      date.setDate(date.getDate() + 30);
      var expires = ";expires=" + date.toUTCString();
      document.cookie = 'ageOver16'+"="+'true'+expires+";path=/";
      
    }
  }

  getAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
  }

}

customElements.define('age-validation', AgeValidation);